const messages = {
  titleColorRev: "true",
  buttons: {
    pending: "Na čekanju",
    open: "Otvori",
    requestAccess: "Zatražite pristup",
  },
  myBsApps: '<span class="text-danger">Moje aplikacije</span> Bridgestone',
  my: "Moje aplikacije",
  directRoute: "Vaše direktne veze ka Bridgestone web aplikacijama.",
  welcomeMessage:
    'Dobrodošli u BRIDGESTONE PLUS <span class="text-danger">PLUS</span>, %{first_name} %{last_name}',
  showProfile: "Prikažite profil",
  newMessages: "Nova poruka u primljenoj pošti",
  myApps: "Moje aplikacije",
  allApps: "Sve aplikacije",
  myAppsDescription: "Sve Bridgestone web aplikacije za koje ste registrovani.",
  allAppsDescription:
    "Sve Bridgestone web aplikacije koje bi vas mogle zanimati.",
  myProfile: {
    welcomeMessage:
      "Dobrodošli u vaš lični prostor. Ovde možete ažurirati ili prilagoditi vaše informacije i pregledati vašu primljenu poštu.",
    masterData: "Osnovni podaci",
    completeDetails:
      "Popunite vaše lične i podatke o kompaniji da osigurate ispravnu registraciju.",
    goToMasterData: "Idite na moje podatke",
    goToInbox: "Idite na primljenu poštu",
  },
  masterData: {
    welcomeMessage:
      "Dobrodošli u vaš lični prostor. Ovde možete ažurirati ili prilagoditi vaše osnovne podatke.",
    personalDetails: "Lični podaci",
    companyDetails: "Podaci o kompaniji",
    emailAddress: "Email adresa",
    title: "Titula",
    surname: "Prezime",
    firstName: "Ime",
    jobPosition: "Radna pozicija",
    streetAndHouseNumber: "Adresa kompanije",
    postalCode: "Poštanski broj",
    city: "Grad",
    country: "Zemlja",
    legalStructure: "Pravna struktura",
    customerNumber: "Bridgestone broj kupca",
    importantPleaseRead: "Važno, molimo pročitajte",
    customerNumberInfo:
      "Da biste ispravno dodelili vaše narudžbe guma različitim trgovcima, važno je da navedete vaš broj kupca.",
    multipleCustomerNumbers:
      "Ako imate više brojeva kupaca kod trgovca, npr. za vašu glavnu kompaniju i podružnice, molimo prvo navedite broj kupca glavne kompanije.",
    salesAssignment:
      "Prodaja povezana sa dodatnim brojevima kupaca će biti dodeljena vašoj glavnoj kompaniji.",
    supplier: "Dobavljač",
    addAnotherCustomerNumber: "Dodajte broj kupca",
    save: "Sačuvajte",
    delete: "Obrišite",
  },
  inbox: {
    welcomeMessage: "Ovde možete pronaći obaveštenja i važne vesti.",
    sender: "Pošiljalac",
    subject: "Predmet",
    date: "Datum",
    formConsulting: "Forma primljena - Hvala vam što ste popunili vaš profil.",
    back: "Nazad",
  },
  legalAndContact: {
    cookieSettings: "Postavke kolačića",
    dataPolicy: "Politika podataka",
    termsOfUse: "Uslovi korišćenja",
    helpAndContact: "Pomoć i kontakt",
  },
  logInSignUp: {
    logIn: "Prijavite se",
    signUp: "Registrujte se",
    logInMessage: "Prijavite se sa vašom email adresom i lozinkom.",
    signUpMessage: "Ako ste novi korisnik, molimo registrujte se.",
  },
};

export default {
  messages,
};
